import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import dummyImage from "../../Assets/Group 1171283252[1].png"; //fallback image
import { ArrowDown } from '../Icons';
import getTranslationData from '../../TranslationUtility/TranslationUtility';
import SelectWidgetCardModel from './SelectWidgetCardModel';
import { getclientConfigDataAsync } from '../../Store/Slices/clientConfigDataSlice';
import { trackEvent } from '../Utility/Utility';

const RewardWidget = ({ ...props }) => {

    const clientInfo = useSelector((state) => state.clientDataReducer);
    const [selectedCard, setSelectedCard] = useState({});
    // const [isOpen, setIsOpen] = useState(false);
    // const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
    const [showCardSection, setShowCardSection] = useState(false);
    const [cardList, setCrdList] = useState([]);
    const translation = getTranslationData();
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const dispatch = useDispatch();
    const cardListData = useSelector((state) => state.clientConfigDataReducer);

    // useEffect(() => {
    //     const handleResize = () => {
    //         setIsMobile(window.innerWidth < 769);
    //     };
    //     window.addEventListener("resize", handleResize);
    //     return () => window.removeEventListener("resize", handleResize);
    // }, []);

    const confirmCardData = (cards) => {
        let sortedActiveCards = [...cards]?.sort((a, b) => a?.displayOrder - b?.displayOrder).filter((card) => card?.isActive);
        let selectdRewardWidget = localStorage.getItem("RewardWidget");
        let selectedCardData = [];
        const setDefaultCard = (defaultCard) => {
            if (defaultCard) {
                selectedCardData = defaultCard;
            }
            else {
                selectedCardData = sortedActiveCards[0];
            }
        }
        if (selectdRewardWidget !== 'undefined' && selectdRewardWidget !== null) {
            selectedCardData = sortedActiveCards?.find(card => card.cardId === selectdRewardWidget);
            if (!selectedCardData) {
                setDefaultCard(selectedCardData);
            }
        }
        else {
            let defaultCard = sortedActiveCards?.find(card => card?.isDefault === true);
            setDefaultCard(defaultCard);
        }
        localStorage.setItem("RewardWidget", selectedCardData?.cardId);
        sortedActiveCards = sortedActiveCards.map((card) => { return card?.cardId === selectedCardData?.cardId ? { ...card, isSelected: true } : { ...card, isSelected: false } })
        setCrdList(sortedActiveCards);
        setSelectedCard(selectedCardData);
        setShowCardSection(true);
    }

    useEffect(() => {
        if (clientInfo) {
            const cardSectionConfig = clientInfo?.clientData?.clientConfigurations?.find((config) => config.configKey === "isrewardwidgete")
            if (cardSectionConfig && cardSectionConfig?.configValue === 1) {
                (async () => {
                    if (cardListData?.clientConfigData?.cards?.length > 0) {
                        confirmCardData(cardListData?.clientConfigData?.cards);
                    }
                    else {
                        await dispatch(getclientConfigDataAsync("widgetdata")).then((res) => {
                            const { cards } = res?.payload?.response || [];
                            if (cards?.length > 0) {
                                confirmCardData(cards);
                            }
                        }).catch((err) => {
                            console.error("Error fetching card list:", err);
                            return { cards: [] };
                        });
                    }
                })();
            }
            else {
                setShowCardSection(false);
                setCrdList([]);
            }
        }
    }, [clientInfo, cardListData])

    const cardSelectHandle = (selectedCard, ind) => {
        setSelectedCard(selectedCard);
        localStorage.setItem("RewardWidget", selectedCard?.cardId);
        let updatedCardList = cardList.map((card) => { return card?.cardId === selectedCard?.cardId ? { ...selectedCard, isSelected: true } : { ...card, isSelected: false } })
        setCrdList(updatedCardList);
        toggleWidgetSelect();
        const rewardPoints = Math.floor((props.totalAmount / selectedCard.perRs) *
            selectedCard.standardPoints *
            ((selectedCard.bonusPoints / selectedCard.standardPoints) + 1))
        trackEvent("select_bank_card", {
            card_name: selectedCard?.cardName,
            reward_points: rewardPoints,
            page_url: window.location.href,
            page_title: window.location.href.includes('/giftcard') ? "pdp" : "checkout_page",
        });
    }
    const handleImageError = (e) => {
        e.target.onerror = null; // Prevent infinite loop if fallback fails
        e.target.src = dummyImage; // Set fallback
    };

    const toggleWidgetSelect = () => setShowModal(!showModal);

    // const selectCard = (card) => {
    //     setSelectedCard(card);
    //     setIsOpen(false);
    // };
    return (

        <>  {/* web view card section*/}
            {/* {
                !isMobile && showCardSection && <div className="container card text-white shadow-sm px-4 py-3 w-100 rounded-4 mb-3"
                    style={{ background: "linear-gradient(180deg, #555353, #222222 )" }}>

                    <h6 className="fw">Calculate Reward Points on:</h6>

                    <div className="cardBox-card mt-1  d-flex align-items-center w-100 text-white fw-semibold" style={{
                        background: "#FFFFFF1A",
                    }}>
                        <div className="truncate px-2 bold flex-grow-1">American Express&reg; {selectedCard?.cardName} </div>
                        <div className="ml-auto"> <ArrowDown color="white"></ArrowDown></div>
                    </div>

                    <span className="cardBox-line"></span>

                    <div className="">
                        <h6 className="text-white">You will earn</h6>
                        <h4 className="fw-bold">{Math.floor(props.totalAmount * selectedCard?.multiplier).toLocaleString()} Reward Points</h4>
                    </div>
                </div>
            } */}

            {/* mobile view card section  */}
            {
                showCardSection &&
                <div className={`container cardBox rounded-4 mb-3 ${props?.className ? ` ${props?.className}` : ""}`}>
                    <div className="cardBox-title">{translation?.calculate_reward_points_on}</div>
                    <div className="cardBox-card rounded-3 mt-1 d-flex align-items-center"
                        onClick={toggleWidgetSelect}
                    >
                        <img src={`${process.env.REACT_APP_CLIENT_URL}${selectedCard?.cardThumbnailUrl}`} onError={handleImageError} alt="CrdImg"></img >
                        <div className="truncate px-3 bold flex-grow-1">{translation?.american_express} {selectedCard?.cardName} </div>
                        <div className="ml-auto cursor-pointer"> <ArrowDown ></ArrowDown></div>
                    </div>

                    {/* {isOpen && cardList?.map((card, index) => {
                        return <div
                            className="cardBox-card mt-1 d-flex align-items-center"
                            key={`${card.cardId}-${index}`}
                            onClick={() => cardSelectHandle(card, index)}
                        >
                            <img src={`${card?.cardThumbnailUrl}`} onError={handleImageError} alt="CrdImg"></img >
                            <div className='px-3 flex-grow-1'>
                                <div className="bold ">{translation?.american_express} {card?.cardName} </div>
                                <h5 className=''>Earn {card.description}</h5>
                            </div>

                            <div className="ml-auto"> <ArrowDown></ArrowDown></div>
                        </div>
                    })} */}

                    <div className="mt-3 two-four-border cardBox-points d-flex justify-content-center align-item-center flex-column">
                        <div style={{ fontSize: '14px' }}>{translation.you_will_earn_label}</div>
                        <div className="fw-bold" style={{ fontSize: '20px' }}>
                            {Math.round((props.totalAmount / selectedCard.perRs) *
                                selectedCard.standardPoints *
                                ((selectedCard.bonusPoints / selectedCard.standardPoints) + 1)).toLocaleString()
                                || 0} {" "} {translation.reward_points}
                        </div>
                    </div>
                    <div className='widget-points-limit'>
                        <p>{translation?.widget_reward_points_limit_txt}</p>
                        <p className='subHeading'>{translation?.points_credited_successful_transaction}</p>
                    </div>
                </div>
            }
            <div className="container">
                {showModal && (
                    <SelectWidgetCardModel
                        // modalDataValue={modalData}
                        show={showModal}
                        modalClass={""}
                        handleClose={handleClose}
                        cardList={cardList}
                        cardSelectHandle={cardSelectHandle}
                    />
                )}
            </div>
        </>
    )
}

export default RewardWidget 